import { render } from "./Logistic.vue?vue&type=template&id=10c3ed7c&scoped=true"
import script from "./Logistic.vue?vue&type=script&lang=js"
export * from "./Logistic.vue?vue&type=script&lang=js"

import "./Logistic.vue?vue&type=style&index=0&id=10c3ed7c&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c3ed7c"]])

export default __exports__